/* eslint-disable camelcase */
import SubItems from '@/components/InspectionReport/Items/SubItems';
import Issues from '@/components/InspectionReport/Items/Issues';
import NegativeAnswers from '@/components/InspectionReport/Items/NegativeAnswers';
import ScoreTable from '@/components/InspectionReport/Items/ScoreTable';
import Overview from '@/components/InspectionReport/Items/Overview';
import Item from '@/components/InspectionReport/Items/Item'; // eslint-disable-line import/no-cycle

const searchNegativeAnswers = (acc, item) => {
    if (item.type === 'question' && item.responded && item.negative) {
        const {
            max_score, score, photos, notes, issues, ...simpleItem
        } = item;
        return [...acc, simpleItem];
    }

    return [
        ...acc,
        ...(item.items ? item.items.reduce(searchNegativeAnswers, []) : []),
    ];
};

export default {
    name: 'HeaderPage',
    functional: true,
    props: {
        item: {
            type: Object,
            required: true,
        },
        resource: {
            type: Object,
            default: null,
        },
    },
    render(h, { props, parent }) {
        const items = [];
        const negativeAnswers = props.resource.form.items
            ? props.resource.form.items.reduce(searchNegativeAnswers, [])
            : [];

        if (!parent.isOnFreePlan) {
            items.push(
                h(Overview, {
                    props: {
                        resource: props.resource,
                        negativeAnswers,
                    },
                }),
            );
        }

        if (props.resource.template.display_score_result_of_pages) {
            items.push(h(ScoreTable, { class: 'mt-6 mb-3', props: { resource: props.resource } }));
        }

        if (props.resource.template.display_site && props.resource.site) {
            items.push(
                h(Item, {
                    props: {
                        item: {
                            title: parent.$t('Site'),
                            type: 'question',
                            response_type: 'site_automatic',
                            params: {
                                automatic: true,
                            },
                        },
                        resource: props.resource,
                    },
                }),
            );
        }

        items.push(
            h(SubItems, {
                props: {
                    items: props.item.items,
                    resource: props.resource,
                },
            }),
        );

        if (props.resource.template.display_negative_answers) {
            items.push(
                h(NegativeAnswers, {
                    props: { items: negativeAnswers, resource: props.resource },
                }),
            );
        }

        if (props.resource.template.display_issues) {
            items.push(h(Issues, { props: { resource: props.resource } }));
        }

        const {
            display_score,
            display_score_result_of_pages,
        } = props.resource.template;
        const headerPageClasses = (display_score && display_score_result_of_pages)
                                  || !(display_score && display_score_result_of_pages)
            ? ''
            : 'border-t border-50';
        return h('div', { class: headerPageClasses }, items);
    },
};
